import App from "./app";
import Home from "./pages/Home/Home";
import Detail from "./pages/VodDetail";
import AccountVerify from "./pages/AccountVerify";
import PasswordReset from "./pages/PasswordReset";
import webinarConfirmationPage from "./pages/webinarConfirmation";
import AuthenticateRedirect from "./pages/AuthenticateRedirect";
import UserPrefrences from "./pages/UserPrefrences";
// import Logout from "./pages/Logout";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import SignUpComplete from "./pages/SignUpComplete";
import SignUpNewComplete from "./pages/SignUpNewComplete"
import ResetPassword from "./pages/ResetPassword";
import Tier from "./pages/Tier";
import Series from "./pages/Series";
import Search from "./pages/Search";
import Delete from "./pages/Delete";
import SeeAll from "./pages/SeeAll";
import pageNotFound404 from "./pages/pageNotFound404";
import pageNotFound500 from "./pages/pageNotFound500";
import MobileProfile from "./pages/MobileProfile";
import WebinarRegistrationPage from "./pages/WebinarRegistrationPage";
import CompanyPage from "./pages/CompanyPage"
import ExpertPage from "./pages/ExpertPage"
import ForyouPage from "./pages/ForyouPage";
import FollowManagement from "./pages/FollowManagement";
import AllEventPage from './pages/AllEventPage';
import EventList from './pages/EventList';
import Event from './pages/Event';
import PrmDetail from "./pages/PrmVodDetail";
// Any change in route needs to be updated in sitemap-routes.js

export default [
  {
    ...App,
    routes: [
      {
        ...Home,
        path: "/",
        exact: true
      },
      {
        ...SignIn,
        path: "/signin"
      },
      {
        ...SignUpComplete,
        path: "/signup/check-email"
      },
      {
        ...SignUpNewComplete,
        path: "/signup/complete"
      },
      {
        ...SignUp,
        path: "/signup"
      },
      {
        ...ResetPassword,
        path: "/resetpassword"
      },
      // {
      //   ...Logout,
      //   path: "/logout"
      // },
      {
        ...AccountVerify,
        path: "/accountVerification"
      },
      {
        ...PasswordReset,
        path: "/forgotPassword"
      },
      {
        ...webinarConfirmationPage,
        path: "/events/success"
      },
      {
        ...Detail,
        path: "/media/:railTitle"
      },
      {
        ...PrmDetail,
        path: "/company-media/:railTitle"
      },
      {
        ...AuthenticateRedirect,
        path: "/authenticate/:token"
      },
      {
        ...UserPrefrences,
        path: "/profile/:prefrences"
      },
      {
        ...MobileProfile,
        path: "/mobileProfile"
      },
      {
        ...WebinarRegistrationPage,
        path: "/events/:eventDatenTitle/:eventId"
      },
      {
        ...pageNotFound500,
        path: "/error-500"
      },
      {
        ...Search,
        path: "/search"
      },
      {
        ...Tier,
        exact: true,
        path: [
          "/topic/:page",
          "/topic/:page/:page2",
          "/topic/:page/:page2/:page3",
          "/topic/:page/:page2/:page3/:page4"
        ]
      },
      {
        ...CompanyPage,
        exact: true,
        path: [
          "/company/:page",
          "/company/:page/:page2",
          "/company/:page/:page2/:page3",
          "/company/:page/:page2/:page3/:page4"
        ]
      },
      {
        ...ExpertPage,
        exact: true,
        path: [
          "/expert/:page",
          "/expert/:page/:page2",
          "/expert/:page/:page2/:page3",
          "/expert/:page/:page2/:page3/:page4"
        ]
      },
      {
        ...Series,
        exact: true,
        path: [
          "/series/:page",
          "/series/:page/:page2",
          "/series/:page/:page2/:page3",
          "/series/:page/:page2/:page3/:page4"
        ]
      },
      {
        ...ForyouPage,
        exact: true,
        path: [
          "/for-you",
        ]
      },
      {
        ...AllEventPage,
        exact: true,
        path: [
          '/all-events',
        ]
      },
      {
        ...EventList,
        exact: true,
        path: [
          "/upcoming-events",
          "/previous-events"
        ]
      },
      {
        ...Event,
        exact: true,
        path: [
          "/event/:railTitle"
        ]
      },
      {
        ...FollowManagement,
        path: "/follow-management"
      },
      {
        ...SeeAll,
        path: "/all/:rail",
        exact: true
      },
      {
        ...Delete,
        path: "/delete"
      },
      {
        ...pageNotFound404
      }
    ]
  }
];
